import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import GISData from './GISData';
import GISPortal from './portal/GISPortal';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate key="gis" path="/gis/data-access" component={GISData} isLoggedIn={isLoggedIn} />,
    <RoutePrivate key="gis-portal" path="/gis/portal" component={GISPortal} isLoggedIn={isLoggedIn} />];
}


// WEBPACK FOOTER //
// ./src/components/gis/GIS.Routes.tsx